import React from 'react';
import { useCurrentModule } from '@wix/package-picker-shared-eclipse';
import { BaseProductCard } from './BaseProductCard';
import { SocialProofProductCard } from './SocialProofProductCard';

interface ProductCardProps {
  productId: string;
}

export const ProductCard = ({ productId }: ProductCardProps) => {
  const module = useCurrentModule();
  const { experiments } = module.internals.experiments.hooks.useExperiments();

  if (experiments.isEnabled('specs.premium.EclipseDesktopSocialProof')) {
    return <SocialProofProductCard productId={productId} />;
  }

  return <BaseProductCard productId={productId} />;
};
